export default __webpack_public_path__ + "static/media/real-estate-property-analytics-logo.ee8d18ca.png";